export function captureScreenshot() {
  const canvas = document.createElement('canvas')

  const video = document.getElementById("video");
  if (canvas instanceof HTMLCanvasElement && video instanceof HTMLVideoElement) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext("2d")

    if (ctx) {
      ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

      return fetch(canvas.toDataURL("image/jpeg", 1.0))
        .then(res => res.blob())
        .then(b => {
          return new File([ b ], 'preview.jpg', {
            type: 'image/jpeg'
          })
        })
        .finally(() => {
          canvas.remove()
        })
    }
  }
}
